import { render, staticRenderFns } from "./BookingZoneSummary.vue?vue&type=template&id=0687b6fa&scoped=true&"
import script from "./BookingZoneSummary.vue?vue&type=script&lang=js&"
export * from "./BookingZoneSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingZoneSummary.vue?vue&type=style&index=0&id=0687b6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687b6fa",
  null
  
)

export default component.exports